// WARNING: this file is AUTOGENERATED, only main.ts and index.ts are editable
// rerun yarn generate:enums to update

import { getSubscriptionStateById } from 'app/constants/enums/SubscriptionState/main';

/* eslint-disable max-len */
export const CURRENT = getSubscriptionStateById('Current');
export const EXPIRED = getSubscriptionStateById('Expired');
export const EXPIRING_SOON = getSubscriptionStateById('ExpiringSoon');
export const NONE = getSubscriptionStateById('None');
export const RECURRING = getSubscriptionStateById('Recurring');
/* eslint-enable max-len */
